import React from 'react';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { ComponentInfo, DisplayGroupRender } from '@components';

export const TopPanel: React.FC<DisplayGroupProps> = (props: DisplayGroupProps) => {
	return (
		<ComponentInfo name="TopPanel">
			<DisplayGroupRender displayGroupsProps={props} />
		</ComponentInfo>
	);
};
